// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lGDxd","heading":"styles_heading__7L4hg","valueWrapper":"styles_valueWrapper__7N0Ds","value":"styles_value__G2KsX","button":"styles_button__SVkzS"};